<div class="mat-table-global documents-table">
  <table [dataSource]="dataSource" mat-table matSort matTableResponsive>
    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.documentName }}</td>
    </ng-container>

    <ng-container matColumnDef="fileSize">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>File Size</th>
      <td mat-cell *matCellDef="let element">
        {{ fileService.formatBytes(element.documentByteSize) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dateUploaded">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Uploaded</th>
      <td mat-cell *matCellDef="let element">
        {{
          datePipe.transform(element.documentCreatedTime, 'MM/dd/yyyy, h:mm a')
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="action-column text-center" mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td class="action-column" mat-cell *matCellDef="let element">
        <div
          class="action-icon-container"
          (click)="downloadFile(element.documentId)">
          <img src="../assets/images/download.svg" alt="View" />
        </div>
      </td>
    </ng-container>

    <tr
      class="table-header-row"
      mat-header-row
      *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="table-data-row"
      mat-row
      *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <ng-container *ngIf="dataSource.data.length === 0">
    <div class="no-documents">
      <img src="/assets/images/multiple-documents.svg" alt="No Documents" />
      <div>No Documents Available</div>
      <div class="sub-text">
        No available reports found at this time. For Sustainability reporting,
        reports are available 30 days from the audit completion.
      </div>
    </div>
  </ng-container>

  <mat-paginator
    class="table-paginator-row"
    [pageSizeOptions]="[10, 20, 30]"
    showFirstLastButtons></mat-paginator>
</div>
